import * as yup from 'yup';
import * as chanceApi from '../../lib/api/chance';
import { useSnackbar } from 'notistack';
import { useFormik } from 'formik';
// @mui
import Paper from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

import Draggable from 'react-draggable';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../components/common/dialog/BootstrapDialog';
import { useBoolean } from '../../hooks/useBoolean';
import SalesCostUploadForm from '../../components/sales-cost-manage/SalesCostUploadForm';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-upload-dialog"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

//application/vnd.openxmlformats-officedocument.spreadsheetml.sheet:xlsx, application/vnd.ms-excel:xls
const SUPPORTED_FORMATS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
const ChanceCostCalcUploadDialog = ({
  title,
  open,
  onClose,
  refreshOnClose,
}) => {
  const isLoading = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  const initialValues = {
    file: null,
  };
  const validationSchema = yup.object({
    file: yup
      .mixed()
      .required('파일을 선택하세요')
      .test('fileFormat', '지정된 XLSX파일만 가능합니다.', (value) => {
        //console.log(value);
        return value && SUPPORTED_FORMATS.includes(value.type);
      }),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (values) => {
    isLoading.onTrue();
    let formData = new FormData();
    formData.append('file', values.file);
    //console.log(formData, 'formData');

    try {
      const response = await chanceApi.uploadExl(formData);
      if (response.data.result === 'success') {
        refreshOnClose(response.data.list);
        enqueueSnackbar('업로드 되었습니다', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    } finally {
      isLoading.onFalse();
    }
  };

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-upload-dialog"
      fullWidth={true}
      maxWidth="sm"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-upload-dialog"
        onClose={handleClose}
      >
        {title}
      </BootstrapDialogTitle>
      <DialogContent
        dividers
        sx={{
          height: 200,
          overflowY: 'auto',
        }}
      >
        {isLoading.value ? (
          <Box sx={{ width: '100%' }}>
            <LinearProgress />
          </Box>
        ) : (
          <SalesCostUploadForm formik={formik} />
        )}
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ChanceCostCalcUploadDialog;
